import { PayloadAction } from '@reduxjs/toolkit';
import { WritableDraft } from 'immer';

import { QuoteBuilderStateType } from '../../types/state';
import { QuotePriceType } from '../../types/state/quote-price';
import {
  getQuoteLineOrThrow,
  getQuotePriceOrThrow,
} from '../utilities/action-guards';
import { buildIssueId } from '../utilities/issue-id';
import { upsertIssue } from '../utilities/issue-managers';

export function quotePriceCreated(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{ quoteLineUuid: string; quotePrice: QuotePriceType }>,
) {
  const { quoteLineUuid, quotePrice } = action.payload;

  const quoteLine = getQuoteLineOrThrow(state, quoteLineUuid);

  quoteLine.quotePriceUuids.push(quotePrice.uuid);

  quoteLine.automatable = false;

  quoteLine.quotePrices[quotePrice.uuid] = quotePrice;
}

export function quotePriceCreationSucceeded(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{ quoteLineUuid: string; quotePriceUuid: string }>,
) {
  const { quoteLineUuid, quotePriceUuid } = action.payload;

  const quotePrice = getQuotePriceOrThrow(state, quoteLineUuid, quotePriceUuid);

  quotePrice.status = 'ready';
}

export function quotePriceCreationFailed(
  state: WritableDraft<QuoteBuilderStateType>,
  action: PayloadAction<{ quoteLineUuid: string; quotePriceUuid: string }>,
) {
  const { quoteLineUuid, quotePriceUuid } = action.payload;

  const quotePrice = getQuotePriceOrThrow(state, quoteLineUuid, quotePriceUuid);

  quotePrice.status = 'creation-failed';

  upsertIssue(
    state,
    buildIssueId({
      area: 'quotePrice',
      quoteLineUuid,
      quotePriceUuid,
      type: 'rejected',
    }),
    {
      title: 'Failed to Create Price',
      description: 'Quote price could not be created in the database',
      area: 'quotePrice',
      quoteLineUuid,
      quotePriceUuid,
      severity: 'error',
      type: 'rejected',
      action: {
        type: 'unrecoverable',
      },
    },
  );
}
